import React, { FC, ReactNode, useMemo } from "react";
import { Document } from "../../../../../document";
import "./documentPreview/DocumentPreview.scss";
import { Popover, Tooltip } from "antd";
import DocumentPreview from "./documentPreview/DocumentPreview";
import {
  isImageDocument,
  isPdfDocument,
} from "../../../../../document/utils/mimeType";

type Props = {
  document: Document;
  children: ReactNode;
};

const DocumentPillHoverAction: FC<Props> = ({ document, children }) => {
  // Anything the browser can render in the popover frame. Without a stored mime type
  // this still comes down to the filename, as it always did.
  const isPreviewable = useMemo(
    () => isPdfDocument(document) || isImageDocument(document),
    [document],
  );

  if (isPreviewable) {
    return (
      <Popover
        content={<DocumentPreview document={document} />}
        placement="rightTop"
        mouseEnterDelay={0.5}
        title={
          <div className="document-pill-popover__title">{document.name}</div>
        }
      >
        {children}
      </Popover>
    );
  }

  return (
    <Tooltip
      placement="top"
      title={<span style={{ whiteSpace: "pre-wrap" }}>{document.name}</span>}
    >
      {children}
    </Tooltip>
  );
};

export default DocumentPillHoverAction;
